package com.trevorwiebe.timesheet.theme

import androidx.compose.ui.graphics.Color

// Light theme colors
val primaryLight = Color(0xFFe3e3e3)
val onPrimaryLight = Color(0xFF000000)
val primaryContainerLight = Color(0xFFE8E8E8)
val onPrimaryContainerLight = Color(0xFF676868)
val secondaryLight = Color(0xFF5E5E5E)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFE4E2E2)
val onSecondaryContainerLight = Color(0xFF656464)
val tertiaryLight = Color(0xFF731A00)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFC29386)
val onTertiaryContainerLight = Color(0xFFFFFFFF)
val errorLight = Color(0xFFD32F2F)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFEF9A9A)
val onErrorContainerLight = Color(0xFFB71C1C)
val backgroundLight = Color(0xFFFFFFFF)
val onBackgroundLight = Color(0xFF1C1B1B)
val surfaceLight = Color(0xFFfaf6f5)
val onSurfaceLight = Color(0xFF1C1B1B)
val surfaceVariantLight = Color(0xFFE0E3E3)
val onSurfaceVariantLight = Color(0xFF444748)
val outlineLight = Color(0xFF747878)
val outlineVariantLight = Color(0xFFC4C7C8)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF313030)
val inverseOnSurfaceLight = Color(0xFFF4F0EF)
val inversePrimaryLight = Color(0xFFC6C6C6)
val surfaceDimLight = Color(0xFFDDD9D9)
val surfaceBrightLight = Color(0xFFfaf6f5)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF6F3F2)
val surfaceContainerLight = Color(0xFFF1EDEC)
val surfaceContainerHighLight = Color(0xFFEBE7E7)
val surfaceContainerHighestLight = Color(0xFFE5E2E1)

val primaryDark = Color(0xFFFFFFFF)
val onPrimaryDark = Color(0xFF2F3131)
val primaryContainerDark = Color(0xFF3b3b3b)
val onPrimaryContainerDark = Color(0xFF636565)
val secondaryDark = Color(0xFFC8C6C6)
val onSecondaryDark = Color(0xFF303030)
val secondaryContainerDark = Color(0xFF494949)
val onSecondaryContainerDark = Color(0xFFB9B8B8)
val tertiaryDark = Color(0xFFE69172)
val onTertiaryDark = Color(0xFF601400)
val tertiaryContainerDark = Color(0xFF80665D)
val onTertiaryContainerDark = Color(0xFF601400)
val errorDark = Color(0xFFD32F2F)
val onErrorDark = Color(0xFFFFFFFF)
val errorContainerDark = Color(0xFFEF9A9A)
val onErrorContainerDark = Color(0xFFB71C1C)
val backgroundDark = Color(0xFF000000)
val onBackgroundDark = Color(0xFFE5E2E1)
val surfaceDark = Color(0xFF141313)
val onSurfaceDark = Color(0xFFE5E2E1)
val surfaceVariantDark = Color(0xFF444748)
val onSurfaceVariantDark = Color(0xFFC4C7C8)
val outlineDark = Color(0xFF8E9192)
val outlineVariantDark = Color(0xFF444748)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE5E2E1)
val inverseOnSurfaceDark = Color(0xFF313030)
val inversePrimaryDark = Color(0xFF5D5F5F)
val surfaceDimDark = Color(0xFF141313)
val surfaceBrightDark = Color(0xFF3A3939)
val surfaceContainerLowestDark = Color(0xFF0E0E0E)
val surfaceContainerLowDark = Color(0xFF1C1B1B)
val surfaceContainerDark = Color(0xFF201F1F)
val surfaceContainerHighDark = Color(0xFF2A2A2A)
val surfaceContainerHighestDark = Color(0xFF353434)

val successGreenBackground = Color(0xFFC8E6C9)
val successGreenText = Color(0xFF388E3C)

val warningYellowBackground = Color(0xFFFB8C00)
val warningYellowText = Color(0xFFFB8C00)

//val disabledButtonTertiaryColor = Color(0XFFb5a39e)